import { Button, Card, Col, DatePicker, Flex, Form, Input, Modal, Row, Select, message } from 'antd'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux';
import axios from 'axios';
import ContactInput from "../../components/ContactInput";
import dayjs from 'dayjs';

function UserEdit({ editData, isLoading, onClose, fetchList, type }) {
    const [form] = Form.useForm()

    useEffect(() => {
        if (editData) {
            form.setFieldsValue({
                fullname: editData.fullname,
                email: editData.email,
                phoneNo: editData.phoneNumber,
                dob: editData?.dob ? dayjs(editData.dob, "DD-MM-YYYY") : null,
                password: editData.password,
                city: editData.city === "-" ? "" : editData.city,
                state: editData.state === "-" ? "" : editData.state,
                country: editData.country === "-" ? "" : editData.country,
                brokerName: editData.brokerName === "-" ? "" : editData.brokerName,
                brokerServer: editData.brokerServer === "-" ? "" : editData.brokerServer,
                accountNumber: editData.accountNumber === "-" ? "" : editData.accountNumber,
                accountName: editData.accountName === "-" ? "" : editData.accountName,
                investorPassword: editData.investorPassword === "-" ? "" : editData.investorPassword,
                masterPassword: editData.masterPassword === "-" ? "" : editData.masterPassword,
            });
        }
    }, [editData]);

    const formSubmit = (val) => {
        let payload = {
            fullName: val.fullname || undefined,
            email: val.email || undefined,
            password: val.password || undefined,
            phoneNumber: val.phoneNo || undefined,
            address: val.address || undefined,
            city: val.city || undefined,
            state: val.state || undefined,
            country: val.country || undefined,
            dob: val.dob || undefined,
            brokerName: val.brokerName || undefined,
            brokerServer: val.brokerServer || undefined,
            accountNumber: val.accountNumber || undefined,
            accountName: val.accountName || undefined,
            investorPassword: val.investorPassword || undefined,
            masterPassword: val.masterPassword || undefined,
        };

        axios.put(`${process.env.REACT_APP_ADMIN_API_URL}admin/edit-user/${editData?.key}`, payload, {
            headers: {
                'x-product-type': 'MAKE_MY_PROFIT'
            }
        })
            .then((response) => {
                message.success("User updated successfully!");
                onClose();
                form.resetFields();
                fetchList()
            })
            .catch((error) => {
                console.error('Error:', error);
                message.error("Something went wrong");
            });
    };

    return (
        <Modal
            open={true}
            title="Edit User"
            onCancel={onClose}
            footer={null}
        >
            <Form form={form} layout="vertical" onFinish={formSubmit}>
                <Row gutter={16}>
                <Col span={12}>
                        <Form.Item label="Broker Name" name="brokerName">
                            <Input placeholder="Enter Broker Name" />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="Broker Server" name="brokerServer">
                            <Input placeholder="Enter Broker Server" />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="Account Number" name="accountNumber">
                            <Input placeholder="Enter Account Number" />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="Account Name" name="accountName">
                            <Input placeholder="Enter Account Name" />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="Investor Password"
                            name="investorPassword"
                        >
                            <Input.Password placeholder="Enter Investor Password" />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="Master Password"
                            name="masterPassword"
                        >
                            <Input.Password placeholder="Enter Master Password" />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="Full Name"
                            name="fullname"
                            rules={[{ required: true, message: "Please Enter full name!" }]}
                        >
                            <Input placeholder="Enter Full Name" />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        {/* <Form.Item
                            label="Phone Number"
                            name="phoneNo"
                            rules={[{ required: true, message: "Please Enter phone number!" }]}
                        >
                            <Input placeholder="Enter Phone Number" />
                        </Form.Item> */}
                         <ContactInput form={form} name="phoneNo" label="Phone Number" require={true} disabled/>
                    </Col>
                    {/* <Col span={12}>
                        <Form.Item label="Full Name" name="fullname" rules={[{ required: true, message: 'Please Enter full name!' }]}>
                            <Input addonBefore={<Select onChange={setuserPreference} style={{ width: 70 }} defaultValue={userPreference} options={[
                                { value: "Mr.", label: "Mr." },
                                { value: "Ms.", label: "Ms." },
                                { value: "Mrs.", label: "Mrs." },
                            ]} />} placeholder="Enter Full Name" />
                        </Form.Item>
                    </Col> */}
                    <Col span={type === 'request' ? 24 : 12}>
                        <Form.Item
                            label="Email Address"
                            name="email"
                            rules={[
                                { required: true, type: "email", message: "Please Enter valid email address!" },
                            ]}
                        >
                            <Input placeholder="Enter Email" readOnly/>
                        </Form.Item>
                    </Col>
                    {type !== 'request' &&
                        <Col span={12}>
                            <Form.Item
                                label="Password"
                                name="password"
                                rules={[{ required: true, message: "Please enter password" }]}
                            >
                                <Input.Password placeholder="Enter Password" />
                            </Form.Item>
                        </Col>
                    }
                    <Col span={12}>
                        <Form.Item
                            label="Date of Birth"
                            name="dob"
                            rules={[{ required: true, message: "Please Enter date of birth!" }]}
                        >
                            <DatePicker format="DD-MM-YYYY" style={{ width: "100%" }} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="City"
                            name="city"
                            rules={[{ required: true, message: "Please Enter city!" }]}
                        >
                            <Input placeholder="Enter City" />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="State"
                            name="state"
                            rules={[{ required: true, message: "Please Enter state!" }]}
                        >
                            <Input placeholder="Enter State" />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="Country"
                            name="country"
                            rules={[{ required: true, message: "Please Enter country!" }]}
                        >
                            <Input placeholder="Enter Country" />
                        </Form.Item>
                    </Col>
                </Row>
                <Button type="primary" htmlType="submit" loading={isLoading}>
                    Save Changes
                </Button>
            </Form>
        </Modal>
    )
}

const mapStateToProps = ({ loading }) => {
    // const {isLoading} = loading
    // return {isLoading}
}

export default connect(mapStateToProps, {})(UserEdit)